import { CircularProgress, Grid } from "@mui/material"
import { useEffect } from "react"
import { DeviceType } from "../../services/ntuc/memberService/oaMembership"
import { extractClientOrderId, extractPaymentResponseContent, getPayment, OrderRequest, PaymentInfo, paymentInfoFromPaymentResponse, postCreateOrder, ServiceType } from "../../services/ntuc/memberService/payment"
import { redirectToPaymentGateway } from "../../services/ntuc/paymentService/payment"
import { MembershipActionType } from "../../store/membership/MembershipReducer"
import { useMembershipStore } from "../../store/membership/MembershipSignupStore"
import { MembershipPaymentRoute, MembershipPaymentRouteProps } from "../../views/membership-payment-flow/MembershipPaymentFlow/MembershipPaymentFlow"

const RetryUpfrontPayment = (props: MembershipPaymentRouteProps) => {
    const { onNavigateTo } = props

    const [membershipState, dispatchEvent] = useMembershipStore()

    useEffect(() => {
        const membershipDetails = membershipState.membershipDetails

        if (membershipDetails != undefined && membershipDetails!.outstandingPaymentId != undefined) {
            resetErrorStatus()

            getPayment(membershipDetails!.outstandingPaymentId)
                .then(extractPaymentResponseContent)
                .then(paymentInfoFromPaymentResponse)
                .then(createOrderRequest)
                .then(triggerPayment)
                .catch(returnWithError)
        } else {
            returnWithError(Error(`Membership details is undefined, which should not happen when reaching this page. Make sure the state is correclty updated in previous page.`))
        }
    }, [membershipState.membershipDetails])

    const createOrderRequest = (paymentInfo: PaymentInfo) => {
        if (!membershipState.membershipDetails) {
            throw Error(`Membership details should not be undefined when invoking this function`)
        }

        return {
            feeType: paymentInfo.feeType,
            endDate: paymentInfo.endDate,
            startDate: paymentInfo.startDate,
            serviceType: ServiceType.SIGN_UP,
            noOfMonths: paymentInfo.month,
            amount: `${paymentInfo.amount}`,
            isOneTimePayment: true,
            isRecurringPayment: false,
            membershipId: membershipState.membershipDetails!.id,
            deviceType: DeviceType.WEB,
        }
    }

    const triggerPayment = (orderRequest: OrderRequest) => {
        postCreateOrder(orderRequest)
            .then(extractClientOrderId)
            .then(redirectToPaymentGateway)
            .catch(returnWithError)
    }

    const returnWithError = (error: Error) => {
        console.error(error)
        dispatchEvent({
            type: MembershipActionType.HAD_ERROR_SETTING_UP_UPFRONT_PAYMENT,
        })
        onNavigateTo(MembershipPaymentRoute.Main)
    }

    const resetErrorStatus = () => {
        dispatchEvent({
            type: MembershipActionType.REST_SETTING_UP_UPFRONT_PAYMENT_ERROR,
        })
    }

    return (
        <Grid container item justifyContent="center" py={6} xs={12}>
            <CircularProgress />
        </Grid>
    )
}

export default RetryUpfrontPayment